import { useEffect, useState } from 'react';
import type { IThirdPartyMessage } from './AdminProcessDetailsThirdPartyMessages';
import type { AdminProcess } from './adminProcessDetailsTypes';
import { RequestStatus } from '../../../../common/enums/requestStatus';
import { ThirdPartyMessageType } from '../../../../common/enums/thirdPartyMessageType';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { Button } from '../../elements/common';

interface IAdminSendEdifactButtonProps {
    adminProcess: AdminProcess;
    onReload: () => Promise<void>;
}

export function AdminSendEdifactButton(props: IAdminSendEdifactButtonProps) {
    const [sendEdifact, setSendEdifact] = useState(false);

    useEffect(() => {
        if (props.adminProcess.status === RequestStatus.completed) {
            loadThirdPartyMessages();
        }
    }, [props.adminProcess.id]);

    if (props.adminProcess.status !== RequestStatus.completed || !sendEdifact) {
        return null;
    }

    return (
        <Button
            color="primary"
            onClick={async () => await handleClick()}
            outlined
        >
            {translateKey('processDetails.sendEdifact')}
        </Button>
    );

    async function handleClick() {
        const url = `/api/requests/${props.adminProcess.id}/sendZorgMail`;
        await fetchJson(url, 'POST');
        await props.onReload();
    }

    async function loadThirdPartyMessages() {
        const url = `/api/requests/${props.adminProcess.id}/thirdPartyMessages?canPerformAction=sendZorgMail`;
        const result = await fetchJson(url, 'GET');

        const edifactMessageTypes = [
            ThirdPartyMessageType.medlab,
            ThirdPartyMessageType.medspe,
            ThirdPartyMessageType.medvri,
        ];
        const messages = result.json.items.filter((item: IThirdPartyMessage) =>
            edifactMessageTypes.includes(item.messageType)
        );
        setSendEdifact(messages.length === 0 && result.json.canPerformAction.sendZorgMail);
    }
}
